/**
 * Countries visited, as shown on /travel.
 *
 * This list is the source of truth for the map — it is not derived from blog
 * posts, so a country counts here whether or not it was ever written up.
 *
 * To add one, append a row and keep the file sorted by `name`:
 *   code  ISO 3166-1 alpha-2, for identity — display names change, codes don't
 *   name  what the rail and the marker label show
 *   lat   marker position, roughly the middle of the country
 *   lng
 *   zoom  how far in to fly when it's opened; bigger country, smaller number
 *
 * After adding one, run `yarn generate-country-shapes` to redraw the shaded
 * outlines — the app reads this file directly, but the country polygons are
 * generated from it into public/travel-countries.geojson.
 *
 * CommonJS so scripts/generate-country-shapes.js can read it too.
 */
const countries = [
  { code: 'BH', name: 'Bahrain', lat: 26.03, lng: 50.55, zoom: 8 },
  { code: 'CA', name: 'Canada', lat: 56.13, lng: -106.35, zoom: 2.6 },
  { code: 'CZ', name: 'Czechia', lat: 49.82, lng: 15.47, zoom: 6 },
  { code: 'DE', name: 'Germany', lat: 51.17, lng: 10.45, zoom: 5 },
  { code: 'IS', name: 'Iceland', lat: 64.96, lng: -19.02, zoom: 5 },
  { code: 'JP', name: 'Japan', lat: 36.2, lng: 138.25, zoom: 4 },
  { code: 'MY', name: 'Malaysia', lat: 4.21, lng: 101.98, zoom: 5 },
  { code: 'OM', name: 'Oman', lat: 21.47, lng: 55.98, zoom: 5.5 },
  { code: 'PK', name: 'Pakistan', lat: 30.38, lng: 69.35, zoom: 4.5 },
  { code: 'QA', name: 'Qatar', lat: 25.35, lng: 51.18, zoom: 7.5 },
  { code: 'SA', name: 'Saudi Arabia', lat: 23.89, lng: 45.08, zoom: 4 },
  { code: 'SG', name: 'Singapore', lat: 1.35, lng: 103.82, zoom: 8.5 },
  { code: 'LK', name: 'Sri Lanka', lat: 7.87, lng: 80.77, zoom: 6.5 },
  { code: 'CH', name: 'Switzerland', lat: 46.82, lng: 8.23, zoom: 6 },
  { code: 'TH', name: 'Thailand', lat: 15.87, lng: 100.99, zoom: 4.8 },
  { code: 'TR', name: 'Turkey', lat: 38.96, lng: 35.24, zoom: 4.8 },
  { code: 'AE', name: 'UAE', lat: 23.95, lng: 54.0, zoom: 6 },
  { code: 'GB', name: 'UK', lat: 54.0, lng: -2.5, zoom: 4.5 },
  { code: 'US', name: 'USA', lat: 39.5, lng: -98.35, zoom: 3 },
  { code: 'VN', name: 'Vietnam', lat: 14.06, lng: 108.28, zoom: 4.8 },
]

module.exports = { countries }
